module.exports = __webpack_public_path__ + "static/media/DSCF0003.81495177.jpg";